<script>
import ElImage from "element-ui/lib/image";
import ElIcon from "element-ui/lib/icon";
// 可选：自定义图片占位符icon

export default {
  name: "SmartImage",
  components: { ElImage, ElIcon },
  props: {
    src: {
      type: [String, File, Blob, Object, Promise],
      default: "",
    },
    preview: {
      type: Boolean,
      default: false,
    },
    // 兼容 el-image props
    fit: String,
    alt: String,
    lazy: Boolean,
    scrollContainer: [String, Object],
    previewSrcList: Array,
    zIndex: Number,
    initialIndex: Number,
    previewTeleported: Boolean,
  },
  data() {
    return {
      source: "",
      loading: false,
      error: false,
      objectUrl: null,
    };
  },
  mounted() {
    this.updateSource(this.src);
  },
  beforeDestroy() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  },
  watch: {
    src: {
      handler(val) {
        this.updateSource(val);
      },
      immediate: true,
    },
  },
  methods: {
    async resolveSrc(input) {
      if (!input) return "";
      if (typeof input === "string") return input;
      if (input instanceof File || input instanceof Blob) {
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = URL.createObjectURL(input);
        return this.objectUrl;
      }
      if (typeof input.then === "function") {
        const awaited = await input;
        return this.resolveSrc(awaited);
      }
      return "";
    },
    async updateSource(val) {
      this.loading = true;
      this.error = false;
      try {
        this.source = await this.resolveSrc(val);
      } catch (e) {
        this.error = true;
        this.source = "";
        // eslint-disable-next-line no-console
        console.error("SmartImage error:", e);
      } finally {
        this.loading = false;
      }
    },
    handleClick() {
      this.$emit("click");
    },
    // updateWidth removed
  },
};
</script>

<template>
  <div
    v-if="loading"
    class="aspect-[16/9] w-full flex items-center justify-center"
  >
    <i class="el-icon-loading"></i>
  </div>
  <el-image
    v-else
    v-bind="{
      fit,
      alt,
      lazy,
      scrollContainer,
      previewSrcList,
      zIndex,
      initialIndex,
      previewTeleported,
    }"
    :src="source"
    @click="handleClick"
    :class="{ 'cursor-pointer': preview }"
    @error="error = true"
  >
    <div slot="error" class="w-full h-full flex justify-center items-center">
      <el-icon :size="32" color="#dedfe0">
        <!-- 可自定义icon，这里用element-ui自带的图片icon -->
        <svg viewBox="0 0 1024 1024" width="32" height="32">
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.2 0-372-166.8-372-372S306.8 140 512 140s372 166.8 372 372-166.8 372-372 372zm-64-256l-96 128h320l-128-170.7-96 128z"
            fill="#dedfe0"
          />
        </svg>
      </el-icon>
    </div>
  </el-image>
</template>
